import { drawerActionTypes } from '../../config/constant'
import { Action } from './types'

export interface DrawersState {
    assetsDrawerState: boolean
    assetsButtonStyle: string
    detectionsDrawerState: boolean
    detectionsButtonStyle: string
}

const initialState: DrawersState = {
    assetsDrawerState: false,
    assetsButtonStyle: 'DrawerButton DrawerClosedButtonLeft',
    detectionsDrawerState: false,
    detectionsButtonStyle: 'DrawerButton DrawerClosedButtonRight',
}

export default function (state = initialState, action: Action) {
    switch (action.type) {
        case drawerActionTypes.OPEN_ASSETS: {
            return { ...state, ...action.payload }
        }
        case drawerActionTypes.CLOSE_ASSETS: {
            return { ...state, ...action.payload }
        }
        case drawerActionTypes.OPEN_DETECTIONS: {
            return { ...state, ...action.payload }
        }
        case drawerActionTypes.CLOSE_DETECTIONS: {
            return { ...state, ...action.payload }
        }
        default: {
            return state
        }
    }
}
